import { useEffect } from 'react'

import { toggleArray } from '@domain-group/javascript-utils'
import { useSetState } from '@domain-group/react-hooks'

interface UseToggleListItemOptions {
  callbacks?: {
    checkItemExistsFn?: (string: string, array: any[]) => boolean,
    itemsUpdatedFn?: (array: any[]) => void,
  },
  defaultItems?: any[],
  toggleArrayOptions?: {
    deepCompare?: boolean,
    useObjectKey?: string,
  },
}

type DefaultState = {
  items: any[],
  inputValue: string,
}

const defaultState: DefaultState = {
  items: [],
  inputValue: '',
}

function useToggleListItem(options: UseToggleListItemOptions = {}) {
  const { callbacks, defaultItems, toggleArrayOptions } = options
  const { checkItemExistsFn, itemsUpdatedFn } = callbacks || {}

  const [state, setState] = useSetState(defaultState)
  const { items, inputValue } = state

  useEffect(() => {
    if (defaultItems){
      setState({ items: defaultItems })
    }
  }, [])

  const itemExists = checkItemExistsFn ? checkItemExistsFn(inputValue, items) : items.includes(inputValue)
  const hasItems = !!items.length

  return {
    callbacks: {
      toggleItem: (item: any) => {
        const updatedArray = toggleArray(items, item, toggleArrayOptions)

        setState({
          inputValue: '',
          items: updatedArray,
        })

        if (itemsUpdatedFn) itemsUpdatedFn(updatedArray)
      },
      setState,
    },
    hasItems,
    inputValue,
    itemExists,
    items,
  }
}

export type UseToggleListItemPayload = ReturnType<typeof useToggleListItem>

export default useToggleListItem
